import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import useToast from 'contexts/ToastProvider/useToast';

const useNoPermissionToast = () => {
  const { t } = useTranslation();
  const { pushToast } = useToast();

  const pushNoPermissionToast = useCallback(
    () =>
      pushToast({
        variant: 'warning',
        title: t('workspaces.no_permission'),
        description: t('workspaces.no_permission_description'),
      }),
    [pushToast, t]
  );

  return pushNoPermissionToast;
};

export default useNoPermissionToast;
